import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

import CreditLineLedger from './CreditLineLedgerModel';
import CreditLineLive from './CreditLineLiveModel';

const CreditLineActivityRecord = Record({
  ledger: null,
  live: null,
});

export default class CreditLineActivity extends CreditLineActivityRecord {
  static deserialize(jsonObject = {}) {
    const mapProperties = {
      ledger: CreditLineLedger.deserialize,
      live: CreditLineLive.deserialize,
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new CreditLineActivity(hydrated);
  }

  get balance() {
    return this.live ? this.live.balance : this.ledger.balance;
  }
}
